import React, { Component } from 'react';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import Select from "@material-ui/core/Select";
import moment from 'moment';
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import Typography from '@material-ui/core/Typography';

import getProfileFetch from '../actions/profile_actions';

import PropTypes from 'prop-types';
// import { withStyles } from '@material-ui/styles';
import '../../src/index.css';

/*
const styles = theme => ({
    inputRoot: {
        //backgroundColor: "pink",
        //"& .MuiAutocomplete-option": {
        //  backgroundColor: "pink"
        //},
        //color: "purple",
        //"& .MuiOutlinedInput-notchedOutline": {
        //  borderColor: "green"
        //},
        //"&:hover .MuiOutlinedInput-notchedOutline": {
        //  borderColor: "red"
        //},
        //"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        //  borderColor: "purple"
        //}
    }
});
*/

class UserInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            open: false,
            profile: this.props.profile,
            tempAwayMessage: "",
            tempAwayTime: "",
            showInvalidError: false,
            value: moment(),
            returnTimeMilliseconds: null,
            setTimeoutActive: false,
            showChangeStatusDialog: false,
        };
    }

    // Opens the menu.
    handleClick = event => {
        console.log("handleClick called");
        console.log("anchorEl before setState: ", this.state.anchorEl);
        this.setState({ anchorEl: event.currentTarget }, () => { console.log("anchorEl after setState: ", this.state.anchorEl); });
        //this.setState({ anchorEl: event.currentTarget });
    };

    // Closes the menu.
    handleClose = () => {
        console.log("handleClose called");
        console.log("anchorEl before setState: ", this.state.anchorEl);
        this.setState({ anchorEl: null }, () => { console.log("anchorEl after setState: ", this.state.anchorEl); });
        this.setState({ anchorEl: null });
    };

    // Opens the away message dialog.
    handleDialogOpen = () => {
        this.setState({ open: true });
    };

    handleDialogClose = () => {
        this.setState({ tempAwayMessage: "" });
        this.setState({ open: false });
        this.setState({ showInvalidError: false });
    };

    handleInAvailable = () => {
        this.setState({
            anchorEl: null,
        }, () => {
            var updatedUser = { ...this.props.profile };
            updatedUser["Status"] = "Available";
            updatedUser["inOffice"] = true; //online
            updatedUser['awayMessage'] = "";
            updatedUser['awayTime'] = "";
            this.props.updateProfile(updatedUser);
            console.log("the user object is now: ", this.props.profile);
            //window.location.reload();
            this.handleClearSetTimeoutActive();
        });
    }

    handleUnavailable = () => {
        this.setState({
            anchorEl: null,
        }, () => {
            var updatedUser = { ...this.props.profile };
            updatedUser["Status"] = "Busy";
            updatedUser["inOffice"] = true; //online
            updatedUser["awayMessage"] = "";
            this.props.updateProfile(updatedUser);
            console.log("the user object is now: ", this.props.profile);
            this.handleClearSetTimeoutActive();
        });
    }

    handleInBusy = () => {
        this.setState({
            anchorEl: null,
            open: true,
            value: moment(),
        });
    }

    handleOutBusy = () => {
        this.setState({
            anchorEl: null,
            open: true,
        }, () => {
            var updatedUser = { ...this.props.profile };
            updatedUser["Status"] = "Busy";
            updatedUser["inOffice"] = false; //offline
            this.props.updateProfile(updatedUser);
            console.log("the user object is now: ", this.props.profile);
        });
    }

    handleOutDone = () => {
        this.setState({
            anchorEl: null,
        }, () => {
            var updatedUser = { ...this.props.profile };
            updatedUser["Status"] = "Done";
            updatedUser["inOffice"] = false;  //offline
            updatedUser['awayMessage'] = "";
            updatedUser['awayTime'] = "";
            this.props.updateProfile(updatedUser);
            console.log("the user object is now: ", this.props.profile);
            this.handleClearSetTimeoutActive();
        });
    }

    handleChange = property => event => {
        if (property === 'awayMessage') {
            this.setState({ tempAwayMessage: event.target.value });
        } else {
            this.setState({ tempAwayTime: event.target.value }); // 24-hr time HH:MM string
            // convert 24-hr to 12-hr AM/PM
            //var suffix = Number(event.target.value.substring(0, 2)) >= 12 ? " PM" : " AM";
            //var hours = ((Number(event.target.value.substring(0, 2)) + 11) % 12 + 1) + ":" + event.target.value.substring(3, 5) + suffix;
            //console.log(hours);
            //this.setState({ tempAwayTime: hours }); // error: speficied value "2:00 PM" does not conform to the required format bc of suffix?
        }
    };

    // handleChangeAutocomplete = (event, value) => {
    handleChangeAutocomplete = (event) => {
        this.setState({ tempAwayMessage: event.target.value });
        console.log("autocomplete", event.target.value);
    };

    // rc-time-picker
    handleValueChange = value => {
        console.log("value: ", value); // moment obj
        console.log("value._d: ", value._d); // Wed Feb 19 2020 13:01:19 GMT-0800 (Pacific Standard Time) 
        console.log("value.format: ", value.format('h:mm a')); // 9:30 am
        console.log("return time milliseconds: ", Date.parse(value._d));
        this.setState({ value });
        this.setState({ returnTimeMilliseconds: Date.parse(value._d) });
        this.setState({ tempAwayTime: value.format('h:mm a') }, () => {
            console.log("tempAwayTime onChange: ", this.state.tempAwayTime);
        });
    };

    //handleTimePicker = (e) => {
    //  console.log("e.target.value: ", e.target.value); // 24-hr time HH:MM
    //};

    handleDialogOK = () => {
        if (this.state.tempAwayMessage === "" || this.state.tempAwayTime === "") {
            this.setState({ showInvalidError: true });
        } else {
            this.setState({
                open: false,
                showInvalidError: false,
            }, () => {
                var updatedUser = { ...this.props.profile };
                updatedUser['awayMessage'] = this.state.tempAwayMessage;
                updatedUser['awayTime'] = this.state.tempAwayTime;
                updatedUser["Status"] = "Busy";
                updatedUser["inOffice"] = true;  //online
                this.setState({ tempAwayMessage: "", tempAwayTime: "" });
                this.props.updateProfile(updatedUser);
            });
            this.setState({ setTimeoutActive: true }, () => {
                this.toggleSetTimeout(); // Calls the function that will start setTimeout if this.state.setTimeoutActive is true
            });
        }
    };

    // Determines whether to initiate setTimeout or clear it
    toggleSetTimeout = () => {
        var timeInterval = this.state.returnTimeMilliseconds - (moment().unix() * 1000);
        console.log("time interval: ", timeInterval);
        if (this.state.setTimeoutActive) {
            this.timer = setTimeout(this.openChangeStatusDialog, timeInterval);
            console.log("SETTIMEOUT INITIATED");
        } else if (!this.state.setTimeoutActive) {
            console.log("setTimeoutActive expected FALSE: ", this.state.setTimeoutActive);
            clearTimeout(this.timer);
        }
    };

    // Opens change status dialog when setTimeout is executed
    openChangeStatusDialog = () => {
        this.setState({ showChangeStatusDialog: true }, () => { console.log("SETTIMEOUT EXECUTED"); });
    };

    // Closes change status dialog after clicking OK
    closeChangeStatusDialog = () => {
        this.setState({ showChangeStatusDialog: false });
    };

    // Clears the setTimeout when user changes their status to Available or Back after being Away
    handleClearSetTimeoutActive = () => {
        if (this.state.setTimeoutActive) {
            console.log("SETTIMEOUT CANCELLED");
            this.setState({ setTimeoutActive: false }, () => {
                this.toggleSetTimeout();
            });
        }
    };

    handleClearTextFields = () => {
        //console.log("clearing text fields");
        this.setState({ tempAwayMessage: "" });
        this.setState({ tempAwayTime: "" });
    };

    // Changes their status without a message/time
    handleDialogNoMessage = () => {
        this.setState({
            open: false, showInvalidError: false, tempAwayTime: "", tempAwayMessage: ""
        }, () => {
            var updatedUser = { ...this.props.profile };
            //console.log("updatedUser: ", updatedUser);
            updatedUser['awayMessage'] = this.state.tempAwayMessage;
            updatedUser['awayTime'] = this.state.tempAwayTime;
            this.props.updateProfile(updatedUser);
        });
    };

    handleAddMinutes = () => {
        this.setState({ value: moment().add(15, 'minutes') }, () => {
            console.log("this.state.value", this.state.value);
            this.setState({ returnTimeMilliseconds: Date.parse(this.state.value._d) });
            this.setState({ tempAwayTime: this.state.value.format('h:mm a') }, () => {
                console.log("tempAwayTime handleAdd: ", this.state.tempAwayTime);
            });
        });
    };

    handleAddHalfHour = () => {
        this.setState({ value: moment().add(30, 'minutes') }, () => {
            console.log("this.state.value", this.state.value);
            this.setState({ returnTimeMilliseconds: Date.parse(this.state.value._d) });
            this.setState({ tempAwayTime: this.state.value.format('h:mm a') }, () => {
                console.log("tempAwayTime handleAdd: ", this.state.tempAwayTime);
            });
        });
    };

    handleAddHour = () => {
        this.setState({ value: moment().add(1, 'hours') }, () => {
            console.log("this.state.value", this.state.value);
            this.setState({ returnTimeMilliseconds: Date.parse(this.state.value._d) });
            this.setState({ tempAwayTime: this.state.value.format('h:mm a') }, () => {
                console.log("tempAwayTime handleAdd: ", this.state.tempAwayTime);
            });
        });
    };

    render() {

        const { anchorEl } = this.state;
        const status = this.props.profile.status;
        const inOffice = this.props.profile.inOffice; // online
        const hasAwayMessage = this.props.profile.awayMessage !== "";
        const format = 'h:mm a';
        /*
        const standardMessages = [
            { title: 'Away' },
            { title: 'Bank' },
            { title: 'Break' },
            { title: 'Lunch' },
            { title: 'Meeting' },
            { title: 'Meeting Conf Room' },
            { title: 'Post Office' },
        ];
        */
        let button;
        let invalidError;
        let availableButton;
        let awayButton;
        let unavailableButton;

        if (inOffice === true && status === "Available") { // online && "Available"
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Available
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#4dd691' }}>check_circle</i>
                </Tooltip>;
        } else if (inOffice === true && status === "Busy" && hasAwayMessage === false) {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Unavailable
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#ff9400' }}>access_time</i>
                </Tooltip>;
        } else if (inOffice === true && status === "Busy" && hasAwayMessage === true) {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Away
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#ff9400' }}>access_time</i>
                </Tooltip>;
        } else if (inOffice === false && status === "Busy") {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Unavailable
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#c94e4e' }}>remove_circle_outline</i>
                </Tooltip>;
        } else if (inOffice === false && status === "Done") {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Offline
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#c4c4c4' }}>highlight_off</i>
                </Tooltip>;
        } else if (inOffice === false && status === "Disconnected") {
            button =
                <Tooltip
                    placement="bottom"
                    title={
                        <React.Fragment>
                            <h6>
                                You are: Disconnected
                  </h6>
                        </React.Fragment>
                    }
                >
                    <i className="material-icons" style={{ color: '#c4c4c4' }}>warning</i>
                </Tooltip>;
        }

        if (this.state.showInvalidError) {
            invalidError = <div style={{ color: 'red', fontSize: '10px' }}>Please enter away message and return time!</div>;
        } else {
            invalidError = <div></div>;
        }

        if ((inOffice && (hasAwayMessage || status === "Busy")) || !inOffice) {
            availableButton = <MenuItem onClick={this.handleInAvailable} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}>Available</MenuItem>;
        } else {
            availableButton = <div></div>;
        }

        if (inOffice && (status === "Available" || (!hasAwayMessage && status === "Busy"))) {
            awayButton = <MenuItem onClick={this.handleInBusy} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}>Away</MenuItem>;
        } else {
            awayButton = <div></div>;
        }

        if (inOffice && hasAwayMessage) {
            unavailableButton = <MenuItem onClick={this.handleUnavailable} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}>Back</MenuItem>;
        } else if (inOffice && status === "Available") {
            unavailableButton = <MenuItem onClick={this.handleUnavailable} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}>Unavailable</MenuItem>;
        } else {
            unavailableButton = <div></div>;
        }

        const { classes } = this.props;

        return (
            <div>

                <Grid container spacing={0}>

                    <Grid item xs={3}>
                        {/*<Tooltip
              placement="bottom"
              title={
                <React.Fragment>
                  <h6>
                    Change Your Status
                  </h6>
                </React.Fragment>
              }
            >
            */}
                        <IconButton
                            aria-owns={anchorEl ? 'simple-menu2' : undefined}
                            aria-haspopup="true"
                            onClick={this.handleClick}
                        >
                            {button}
                        </IconButton>
                        {/*</Tooltip>*/}

                        <Dialog
                            open={this.state.open}
                            //onClose={this.handleDialogClose}
                            aria-labelledby="form-dialog-title"
                            PaperProps={{ style: { minWidth: '195px' } }}
                        >
                            <DialogTitle id="form-dialog-title" style={{ paddingTop: '5px', paddingLeft: '5px', paddingBottom: '0px' }}>Away Message</DialogTitle>
                            <DialogContent style={{ paddingLeft: '5px', paddingRight: '5px', paddingBottom: '0px', paddingTop: '0px' }}>
                                <Select
                                    required
                                    style={{ padding: '5px', marginTop: '5px' }}
                                    onChange={this.handleChangeAutocomplete}
                                    label="Message"
                                    margin="normal"
                                    fullWidth
                                    type="string"
                                    id="message"
                                    value={this.state.tempAwayMessage}
                                >
                                    <MenuItem value={"Admin"}>Admin</MenuItem>
                                    <MenuItem value={"Away"}>Away</MenuItem>
                                    <MenuItem value={"Bank"}>Bank</MenuItem>
                                    <MenuItem value={"Break"}>Break</MenuItem>
                                    <MenuItem value={"Finishing"}>Finishing</MenuItem>
                                    <MenuItem value={"Front Modular"}>Front Modular</MenuItem>
                                    <MenuItem value={"Lunch"}>Lunch</MenuItem>
                                    <MenuItem value={"Meeting"}>Meeting</MenuItem>
                                    <MenuItem value={"Meeting Conf Room"}>Meeting Conf Room</MenuItem>
                                    <MenuItem value={"Post Office"}>Post Office</MenuItem>
                                    <MenuItem value={"Production"}>Production</MenuItem>
                                    <MenuItem value={"Sales Room"}>Sales Room</MenuItem>
                                    <MenuItem value={"Doctor"}>Doctor</MenuItem>
                                    <MenuItem value={"Other"}>Other</MenuItem>
                                </Select>
                                {/*
                                <Autocomplete
                                    style={{ padding: '0px' }}
                                    onChange={this.handleChangeAutocomplete}
                                    id="free-solo-demo"
                                    freeSolo
                                    options={standardMessages.map(option => option.title)}
                                    //ListboxProps={{ style: { minHeight: '25px' } }}
                                    //ListboxComponent={ListboxComponent}

                                    // className={classes.inputRoot}
                                    renderInput={params => (
                                        <TextField {...params}
                                            required
                                            label="Message"
                                            margin="normal"
                                            fullWidth
                                            type="string"
                                            id="message"
                                            value={this.state.tempAwayMessage}
                                            onChange={this.handleChange('awayMessage')}
                                            style={{ marginTop: '5px' }}
                                        />
                                    )}
                                />
                                */}
                                {/*
                <TextField
                  autoFocus
                  required
                  margin="normal"
                  id="message"
                  label="Message"
                  type="string"
                  fullWidth
                  value={this.state.tempAwayMessage}
                  onChange={this.handleChange('awayMessage')}
                  style={{ marginTop: '5px' }}
                />
                */}

                                {/*
                <TextField
                  required
                  margin="normal"
                  id="time"
                  label="Back by"
                  type="string"
                  fullWidth
                  value={this.state.tempAwayTime}
                  onChange={this.handleChange('awayTime')}
                  style={{ marginTop: '5px' }}
                />
                */}

                                <p style={{ fontSize: '10px', marginTop: '10px', marginBottom: '3px', fontWeight: 'bold' }}>Return Time</p>

                                <div>
                                    <Grid container justify="center" spacing={0}>
                                        <Grid item xs={4} style={{}}>
                                            <Tooltip
                                                placement="bottom"
                                                title={
                                                    <React.Fragment>
                                                        <h6>
                                                            Add 15 minutes
                            </h6>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button size="small" onClick={this.handleAddMinutes} style={{ padding: '0px', marginBottom: '5px' }}>
                                                    <Typography>+ 15min</Typography>
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={4} style={{}}>
                                            <Tooltip
                                                placement="bottom"
                                                title={
                                                    <React.Fragment>
                                                        <h6>
                                                            Add 30 minutes
                            </h6>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button size="small" onClick={this.handleAddHalfHour} style={{ padding: '0px', marginBottom: '5px' }}>
                                                    <Typography>+ 30min</Typography>
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Tooltip
                                                placement="bottom"
                                                title={
                                                    <React.Fragment>
                                                        <h6>
                                                            Add 1 hour
                            </h6>
                                                    </React.Fragment>
                                                }
                                            >
                                                <Button size="small" onClick={this.handleAddHour} style={{ padding: '0px', marginBottom: '5px' }}>
                                                    <Typography>+ 1hr</Typography>
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </div>

                                <Grid container justify="center" spacing={0}>
                                    <Grid item xs={12} style={{ paddingLeft: '7px' }}>
                                        <TimePicker
                                            value={this.state.value}
                                            //defaultValue={this.state.value}
                                            //defaultValue={moment()}
                                            showSecond={false}
                                            onChange={this.handleValueChange}
                                            use12Hours
                                            format={format}
                                        />
                                    </Grid>
                                </Grid>

                                {/*
                <TextField
                  autoFocus
                  required
                  margin="normal"
                  id="time"
                  label="Back by"
                  type="time" // material ui time picker
                  fullWidth
                  value={this.state.tempAwayTime}
                  onChange={this.handleChange('awayTime')}
                />
                */}

                                {invalidError}
                            </DialogContent>
                            <DialogActions style={{ margin: '0px' }}>
                                <Button onClick={this.handleDialogClose} color="primary" style={{ margin: '0px' }}>
                                    Cancel
                </Button>
                                <Button onClick={this.handleDialogOK} color="primary" style={{ margin: '0px' }}>
                                    Save
                </Button>
                            </DialogActions>
                        </Dialog>
                        <Menu
                            id="simple-menu2"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={this.handleClose}
                            MenuListProps={{ style: { padding: '0px' } }}
                        >
                            {availableButton}
                            {unavailableButton}
                            {awayButton}
                        </Menu>
                        <Dialog
                            open={this.state.showChangeStatusDialog}
                            aria-labelledby="form-dialog-title"
                            style={{ margin: '5px !important' }}
                            PaperProps={{ style: { minWidth: '180px' } }}
                        >
                            <DialogTitle id="form-dialog-title" style={{ fontWeight: 'bold', paddingTop: '5px', paddingLeft: '5px', paddingBottom: '0px' }}>
                                <Typography style={{ fontSize: '17px' }}>
                                    Update Status
                </Typography>
                            </DialogTitle>
                            <DialogContent style={{ fontSize: '11px', paddingLeft: '5px', paddingRight: '5px', paddingBottom: '0px' }}>
                                Your return time has elapsed, please update your status!
              </DialogContent>
                            <DialogActions style={{ margin: '0px' }}>
                                <Button onClick={this.closeChangeStatusDialog} color="primary" style={{ margin: '0px', padding: '0px', fontSize: '10px' }}>
                                    CLOSE
                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>

                    <Grid item xs={6} style={{ paddingLeft: '25px', paddingTop: '6px' }}>
                        <h4 style={{ 'cursor': 'default' }}>TeamX</h4>
                    </Grid>

                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.profile
    };
}

const mapDispatchToProps = dispatch => ({
    updateProfile: user => dispatch(getProfileFetch['UPDATE_PROFILE'](user))
})

/*
UserInfo.propTypes = {
    classes: PropTypes.object.isRequired,
};
*/
// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserInfo));
export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);


// WEBPACK FOOTER //
// ./src/components/UserInfo.js